import { queryStorefrontApi } from './queryStorefrontApi';
import { productMediaMetaobject } from '../gql';

const queryMetaobject = async (id) => {
  const query = productMediaMetaobject;
  const variables = { id };
  const res = await queryStorefrontApi(query, variables);

  const metaobject = res?.body?.metaobject;

  if (!metaobject) {
    return {
      status: 404,
      error: 'Metaobject not found',
    };
  }

  return metaobject.fields[0];
};

const formatData = (data) => {
  const dataArray = data.references?.edges;
  if (!dataArray) {
    return [];
  }

  return dataArray.map((item) => {
    const { node } = item;
    if (node.mediaContentType === 'VIDEO') {
      return {
        mediaContentType: 'VIDEO',
        image: node.previewImage,
        sources: node.sources,
      };
    }
    return {
      mediaContentType: 'IMAGE',
      image: node.image,
    };
  });
};

export default async (id) => {
  try {
    const data = await queryMetaobject(id);

    if (data.status === 404) {
      return data;
    }

    return formatData(data);
  } catch (error) {
    console.error('Error:', error);
    return {
      status: 500,
      error: 'Error receiving data',
    };
  }
};
